import styles from './style.module.scss';

export const PanelConstants = {
    graphTypes: {
        HEATMAP: 'HEATMAP',
        COLUMN: 'COLUMN',
        SCATTERPLOTLINE: 'SCATTERPLOTLINE',
        DONUT: 'DONUT',
        STACKEDBAR: 'STACKEDBAR',
        STACKEDCOLUMN: 'STACKEDCOLUMN',
        COMBOCOLUMNLINE: 'COMBOCOLUMNLINE',
        RADIAL: 'RADIAL',
        SANKEY: 'SANKEY',
        SPARKLINE: 'SPARKLINE',
        BUBBLE: 'BUBBLE',
    },

    modelTypes: {
        TRIOPERATIONAL: 'TRIOPERATIONAL',
    },
};

export const Colours = {
    RED: styles['rag-colour-red'],
    AMBER: styles['rag-colour-amber'],
    GREEN: styles['rag-colour-green'],
    PURPLE: '#420080',
    GOLD: '#e0b700',
    LIGHT_BLUE: '#027db4',
    DARK_BLUE: '#003366',
    BLACK: '#000000',
    GREY: '#EEEEEE',
};

export enum ScoreColor {
    None,
    Red,
    Amber,
    Green,
    Purple,
    Grey,
}

export enum SiteTrend {
    NoMovement,
    NoTrend,
    Falling,
    Rising,
    Stable,
    NotEnoughData,
}

export enum ScoreDirection {
    Upper = 0,
    Lower = 1,
    Matching = 2,
}

export enum ColorDirectionThreshold {
    UpperRed = 0,
    UpperAmber = 1,
    LowerAmber = 2,
    LowerRed = 3,
    Grey = 4,
    Green = 5,
}

export type GraphType = keyof typeof PanelConstants.graphTypes;
